import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import CreateNewOrder from './CreateNewOrder'
import pendingApprovalSelectors from '../../../../../redux/PendingOrder/selectors'
import userProfileSelectors from '../../../../../../src/redux/UserProfile/selectors'
import TotalOrder from '../../../../assets/images/MyOrders/My Orders.svg'
import TotalOrderActive from '../../../../assets/images/MyOrders/My Orders_Active.svg'
import Submitted from '../../../../assets/images/MyOrders/Submitted.svg'
import SubmittedActive from '../../../../assets/images/MyOrders/Submitted_Active.svg'
import Approved from '../../../../assets/images/MyOrders/Approved.svg'
import ApprovedActive from '../../../../assets/images/MyOrders/Approved_Active.svg'
import moment from 'moment';
import permissions, { isAuthorized } from 'client/utils/Permissions';
import userSelectors from 'redux/UserProfile/selectors';
import GridFiltersAction from "Store/Component/GridDataFilters/GridDataFiltersAction"
import { HOME_ACTIVE_MENU } from "../../../../utils/constants/homeGridConstants"
import { CONSTANTS } from 'client/utils/constants';
import { FLEET_PROCESSING_PERMISSIONS } from 'client/utils/constants/fleetProcessingPermissions';
import { getGridOrdersCount } from 'redux/PendingOrder/action';
import { getFleetProcessorList } from 'Store/OrderManagement/OrderGridDropdowns/OrderGridDropdownsAction';
import { commonExportExcel } from 'utils';

const searchOptions = [
  { value:'orderId',label:'Order#'},
  { value:'assetNo',label:'Asset#'},
  { value:'poNumber',label:'PO#'},
  { value:'vinSerial',label:'VIN/SN'},
  { value:'unitBarcode',label:'Unit/Barcode #'}
];

const CreateNewOrderContainer = () => {

  const [selectedDispositionKey, setSelectedDispositionKey] = useState<any>();
  const [selectedBuyerNameKey, setSelectedBuyerNameKey] = useState<any>();
  const [activeMenu, setactiveMenu] = useState("")
  const [gridData, setgridData] = useState<any>([])
  const [filteredOrderList, setFilteredOrderList] = useState<any>([])
  const [approvalOrderCount, setApprovalOrderCount] = useState<any>(0)
  const [allPendingApprovalCount, setAllPendingApprovalCount] = useState<any>(0)
  const [myOrderCount, setMyOrderCount] = useState<any>(0)
  const [fleetAdminOrderCount, setFleetAdminOrderCount] = useState<any>(0)
  const [showGrid, setShowGrid] = useState<boolean>(false)
  const [clearFiltersKey, setClearFiltersKey] = useState<number>(0)
  const [searchBoxValue, setsearchBoxValue] = useState('')
  const [serverTotal, setServerTotal] = useState(0)
  const [serverPageNumber, setServerPageNumber] = useState<number>(1)
  const [dateRange, setdateRange] = useState<any>([]);
  const [assignedToTemp, setAssignedTotemp] = useState<any>([]);
  const [requestedByTemp, setRequestedByTemp] = useState<any>([]);
  const [regionTemp, setRegionTemp] = useState<any>([]);
  const [costCenterTemp, setCostCenterTemp] = useState<any>([]);
  const [updatedByTemp, setUpdatedByTemp] = useState<any>([]);
  const [selectedAssignedTo, setSelectedAssignedTo] = useState({ value:'All',label:'All'})
  const [globalSearchBy, setGlobalSearchBy] = useState<any>({ value:'orderId',label:'Order#'})
  const [activeHomeFilterState, setActiveHomeFilterState] = useState('PENDING APPROVALS ORDER')
  const [dispositionTypeList, setDispositionTypeList] = useState<any>();
  const [buyerNameList, setBuyerNameList] = useState<any>();
  const [assignedToColList, setAssignedToColList] = useState<any>([])
  const dispatch = useDispatch();
  const latestSelectedMenuRef = useRef<string | null>(null)
  const gridRefreshTimeoutRef = useRef<number | undefined>(undefined)

  const [showUserManagementPopup, setshowUserManagementPopup] = useState(false);
  const hidePopup = () => {
    setshowUserManagementPopup(false);
  };

  const scheduleGridRefresh = useCallback(() => {
    if (gridRefreshTimeoutRef.current !== undefined) {
      window.clearTimeout(gridRefreshTimeoutRef.current)
    }

    setShowGrid(false)
    gridRefreshTimeoutRef.current = window.setTimeout(() => {
      setShowGrid(true)
    }, 0)
  }, [])


  const {
    gridColumns,
    userDetails,
    BranchList,
    fleetProcessingGridData,
    pendingApprovalGridFilters,
    myOrdersGridFilters,
    fleetProcessingGridFilters,
    pendingOrdersGridData,
    myOrdersGridData,
    gridOrdersCount,
    allPendingApprovalGridFilters,
    allPendingGridData,
    regionList,
    costCenterList,
    requestedByList,
    assignedToList,
    updatedByList,
    dispositionChoiceList,
    bulkOrderTotalOrderFilters,
    bulkOrderSavedOrderFilters,
    requestTotalOrderFilters,
    requestSavedOrderFilters,
    requestPendingApprovalFilters,
    requestFleetProcessingGridFilters,
    requestCompletedGridFilters,
    requestRetuernedGridFilters,
    requestPendingFleetGridFilters,
    requestRejectedGridFilters,
    requestCancelledGridFilters,
    assetTotalOrderFilters,
    assetSavedOrderFilters,
    assetPendingApprovalFilters,
    assetFleetProcessingGridFilters,
    assetCompletedGridFilters,
    assetRetuernedGridFilters,
    assetPendingFleetGridFilters,
    assetRejectedGridFilters,
    assetCancelledGridFilters,
    bulkOrderPendingApprovalFilters,
    bulkOrderFleetProcessingGridFilters,
    bulkOrderCompletedGridFilters,
    bulkOrderReturnedGridFilters,
    bulkOrderRejectedGridFilters,
    bulkOrderCancelledGridFilters,
    isGridCountsLoading,
    buyerNameDropDownList,
    fleetProcessorsList
  }: any = useSelector(
    (state: any) => ({
      gridColumns: pendingApprovalSelectors.gridColumns(state),
      userDetails: userProfileSelectors.getUserDetails(state),
      BranchList: userSelectors.BranchList(state),
      fleetProcessingGridData: pendingApprovalSelectors.fleetProcessingGridData(state),
      pendingApprovalGridFilters: state.GridFiltersReducer.pendingApprovalGridFilters,
      myOrdersGridFilters: state.GridFiltersReducer.myOrdersGridFilters,
      fleetProcessingGridFilters: state.GridFiltersReducer.fleetProcessingGridFilters,
      pendingOrdersGridData: state?.PendingOrder?.pendingOrdersGridData,
      myOrdersGridData: state?.PendingOrder?.myOrdersGridData,
      gridOrdersCount: state?.PendingOrder?.gridOrdersCount,
      allPendingApprovalGridFilters: state?.GridFiltersReducer?.allPendingApprovalGridFilters,
      allPendingGridData: state?.PendingOrder?.allPendingGridData,
      regionList: state.OrderGridDropdownsReducer.regionList,
      costCenterList: state.OrderGridDropdownsReducer.costCenterList,
      requestedByList: state.OrderGridDropdownsReducer.requestedByList,
      assignedToList: state.OrderGridDropdownsReducer.assignedToList,
      updatedByList: state.OrderGridDropdownsReducer.updatedByList,
      dispositionChoiceList: state.DispositionChoiceReducer.dispositionChoiceList,
      bulkOrderTotalOrderFilters: state.GridFiltersReducer.bulkOrderTotalOrderFilters,
      bulkOrderSavedOrderFilters: state.GridFiltersReducer.bulkOrderSavedOrderGridFilters,
      requestTotalOrderFilters: state.GridFiltersReducer.requestTotalOrderGridFilters,
      requestSavedOrderFilters: state.GridFiltersReducer.requestSavedOrderGridFilters,
      requestPendingApprovalFilters: state.GridFiltersReducer.requestPendingApprovalGridFilters,
      requestFleetProcessingGridFilters: state.GridFiltersReducer.requestFleetProcessingGridFilters,
      requestCompletedGridFilters: state.GridFiltersReducer.requestCompletedGridFilters,
      requestRetuernedGridFilters: state.GridFiltersReducer.requestRetuernedGridFilters,
      requestPendingFleetGridFilters: state.GridFiltersReducer.requestPendingFleetGridFilters,
      requestRejectedGridFilters: state.GridFiltersReducer.requestRejectedGridFilters,
      requestCancelledGridFilters: state.GridFiltersReducer.requestCancelledGridFilters,
      assetTotalOrderFilters: state.GridFiltersReducer.assetTotalOrderGridFilters,
      assetSavedOrderFilters: state.GridFiltersReducer.assetSavedOrderGridFilters,
      assetPendingApprovalFilters: state.GridFiltersReducer.assetPendingApprovalGridFilters,
      assetFleetProcessingGridFilters: state.GridFiltersReducer.assetFleetProcessingGridFilters,
      assetCompletedGridFilters: state.GridFiltersReducer.assetCompletedGridFilters,
      assetRetuernedGridFilters: state.GridFiltersReducer.assetRetuernedGridFilters,
      assetPendingFleetGridFilters: state.GridFiltersReducer.assetPendingFleetGridFilters,
      assetRejectedGridFilters: state.GridFiltersReducer.assetRejectedGridFilters,
      assetCancelledGridFilters: state.GridFiltersReducer.assetCancelledGridFilters,
      bulkOrderPendingApprovalFilters: state.GridFiltersReducer.bulkOrderPendingApprovalGridFilters,
      bulkOrderFleetProcessingGridFilters: state.GridFiltersReducer.bulkOrderFleetProcessingGridFilters,
      bulkOrderCompletedGridFilters: state.GridFiltersReducer.bulkOrderCompletedGridFilters,
      bulkOrderReturnedGridFilters: state.GridFiltersReducer.bulkOrderReturnedGridFilters,
      bulkOrderRejectedGridFilters: state.GridFiltersReducer.bulkOrderRejectedGridFilters,
      bulkOrderCancelledGridFilters: state.GridFiltersReducer.bulkOrderCancelledGridFilters,
      isGridCountsLoading: state?.PendingOrder?.isGridCountsLoading,
      buyerNameDropDownList: state.OrderGridDropdownsReducer.buyerNameList,
      fleetProcessorsList: state.OrderGridDropdownsReducer.fleetProcessorsList,
    }));

  const getUserRoles = () => {
    let roles = userDetails?.roles?.map((role: any) => role.roleName)
    return roles
  }

  const orderListApprover = [
    {
      link: approvalOrderCount,
      text: 'PENDING APPROVALS ORDER',
      icon: Submitted,
      activeIcon: SubmittedActive,
      icontype: 'submitted ',
      active: 'active'
    },
    {
      link: myOrderCount,
      text: 'MY ORDERS',
      icon: TotalOrder,
      activeIcon: TotalOrderActive,
      icontype: 'totalOrder '
    },
    {
      link: fleetAdminOrderCount,
      text: HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING,
      icon: Approved,
      activeIcon: ApprovedActive,
      icontype: 'approved '
    }
  ]

  const superAdminUserGrid = [
    {
      link: approvalOrderCount,
      text: HOME_ACTIVE_MENU.PENDING_APPROVALS_ORDER,
      icon: Submitted,
      activeIcon: SubmittedActive,
      icontype: 'submitted ',
      active: 'active'
    },
    {
      link: myOrderCount,
      text: HOME_ACTIVE_MENU.MY_ORDERS,
      icon: TotalOrder,
      activeIcon: TotalOrderActive,
      icontype: 'totalOrder '
    },
    {
      link: allPendingApprovalCount,
      text: HOME_ACTIVE_MENU.ALL_PENDING_APPROVAL,
      icon: Submitted,
      activeIcon: SubmittedActive,
      icontype: 'submitted '
    },
    {
      link: fleetAdminOrderCount,
      text: HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING,
      icon: Approved,
      activeIcon: ApprovedActive,
      icontype: 'approved '
    }
  ]

  const EquipmentOrderList = [
    {
      link: approvalOrderCount,
      text: 'PENDING APPROVALS ORDER',
      icon: Submitted,
      activeIcon: SubmittedActive,
      icontype: 'submitted ',
      active: 'active'
    },
    {
      link: myOrderCount,
      text: 'MY ORDERS',
      icon: TotalOrder,
      activeIcon: TotalOrderActive,
      icontype: 'totalOrder '
    }
  ]

  const orders = [
    {
      link: myOrderCount,
      text: 'MY ORDERS',
      icon: TotalOrder,
      activeIcon: TotalOrderActive,
      icontype: 'totalOrder '
    }
  ]

  const approvalsPending = [
    {
      link: approvalOrderCount,
      text: 'PENDING APPROVALS ORDER',
      icon: Submitted,
      activeIcon: SubmittedActive,
      icontype: 'submitted ',
      active: 'active'
    }
  ]


  useEffect(() => {
    if (userDetails.emailId) {
      setshowUserManagementPopup(false);
      dispatch(getGridOrdersCount(userDetails?.emailId))
      !(fleetProcessorsList?.length > 0) && dispatch(getFleetProcessorList())
    }
  }, [userDetails]);

  useEffect(() => {
    const dropdownList: any = regionList?.map((item: any) => {
      return { label: item.text, key: item.value, ...item }
    })
    setRegionTemp(dropdownList)
  }, [regionList])

  useEffect(() => {
    const dropdownList: any = costCenterList?.map((item: any) => {
      return { label: item.text, key: item.value, ...item }
    })
    setCostCenterTemp(dropdownList)
  }, [costCenterList])

  useEffect(() => {
    const dropdownList: any = requestedByList?.map((item: any) => {
      return { label: item.text, key: item.value, ...item }
    })
    setRequestedByTemp(dropdownList)
  }, [requestedByList])

  useEffect(() => {
    const dropdownList = fleetProcessorsList?.map((item: any) => {
      return { label: item.text, key: item.value, ...item }
    })
    dropdownList?.unshift({label:"All", key: "All", value: "All"})
    setAssignedTotemp(dropdownList)
  }, [fleetProcessorsList])

  useEffect(() => {
    const dropdownList = assignedToList?.map((item: any) => {
      return { label: item.text, key: item.value, ...item }
    })
    setAssignedToColList(dropdownList)
  }, [assignedToList])

  useEffect(() => {
    const dropdownList = updatedByList?.map((item: any) => {
      return { label: item.text, key: item.value, ...item }
    })
    setUpdatedByTemp(dropdownList)
  }, [updatedByList])

  useEffect(() => {
    const dispositionChoiceDropdownList : any = dispositionChoiceList?.map((item: any) =>
    ({ label: item.text, key: item.value, ...item })
    );
    setDispositionTypeList(dispositionChoiceDropdownList)
  },[dispositionChoiceList])

  useEffect(() => {
    const BuyerNameDropdownListTemp: any = buyerNameDropDownList?.map((item: any) =>
      ({ label: item.text, key: item.value, ...item })
    );
    setBuyerNameList(BuyerNameDropdownListTemp)
  }, [buyerNameDropDownList])

  useEffect(() => {
    setshowUserManagementPopup(false);
    setShowGrid(true);
  }, []);

  useEffect(() => {
    if (gridOrdersCount?.pendingApproval > 0 || gridOrdersCount?.myOrders > 0 || gridOrdersCount?.fleetProcessing > 0) {
      if(isAuthorized(permissions.SuperApproval_Approvals) || isAuthorized(permissions.ApprovalsView)){
        setAllPendingApprovalCount(gridOrdersCount?.allPendingApproval)
     }
      if (isAuthorized(permissions.ApprovalsView) || isAuthorized(permissions.CreateUpdatePurchaseOrders)) {
        setApprovalOrderCount(gridOrdersCount?.pendingApproval)
        setMyOrderCount(gridOrdersCount?.myOrders)
        setFleetAdminOrderCount(gridOrdersCount?.fleetProcessing);
      } else {
        setMyOrderCount(gridOrdersCount?.myOrders)
      }
    }
  }, [JSON.stringify(gridOrdersCount)])

  useEffect(() => {
    return () => {
      if (gridRefreshTimeoutRef.current !== undefined) {
        window.clearTimeout(gridRefreshTimeoutRef.current)
      }
    }
  }, [])

  const searchByOptions = useMemo(()=>{
    if(activeMenu === HOME_ACTIVE_MENU?.PENDING_FLEET_PROCESSING){
      return [...searchOptions, { value:'buyerName', label:'Buyer Name'}]
    } else{
      return searchOptions
    }
  }, [activeMenu])



  useEffect(() => {
    if (costCenterTemp?.length && updatedByTemp?.length && assignedToTemp?.length && requestedByTemp?.length && regionTemp?.length && dispositionTypeList?.length && buyerNameList?.length && userDetails?.hasOwnProperty('userGridFilters')) {
      setSavedFilterValues()
    }
  }, [costCenterTemp, updatedByTemp, assignedToTemp, requestedByTemp, regionTemp, dispositionTypeList, buyerNameList, userDetails])

  const alreadyHasValues = (GridFilterValueTemp?: any) => {
    let isAlreadyHasValues = false
    Object.keys(clearFilterValues)?.forEach((filterItem?: any) => {
      Object.keys(GridFilterValueTemp ?? {})?.forEach((gridItem?: any) => {
        if(filterItem == gridItem){
          isAlreadyHasValues =  true
        }
      })
    })
    return isAlreadyHasValues
  }

  const setSavedFilterValues = () => {
    if (userDetails?.hasOwnProperty('userGridFilters')) {
      userDetails?.userGridFilters?.map((item?: any) => {
        item?.gridFilter?.map((gridFilterItem?: any) => {
          let filterObj: any = {}
          let fromDateVal = ""
          let toDateVal = ""
          gridFilterItem?.filterValues?.map((filterItem?: any) => {
            if (filterItem?.filterName == "FromDate") {
              fromDateVal = filterItem?.filterValue ? filterItem?.filterValue : "";
              if (fromDateVal != "" && toDateVal != "") {
                filterObj["dateRange"] = (fromDateVal && toDateVal) ? [new Date(fromDateVal), new Date(toDateVal)] : null
              }
            } else if (filterItem?.filterName == "ToDate") {
              toDateVal = filterItem?.filterValue ? filterItem?.filterValue : "";
              if (fromDateVal != "" && toDateVal != "") {
                filterObj["dateRange"] = (fromDateVal && toDateVal) ? [new Date(fromDateVal), new Date(toDateVal)] : null
              }
            } else if (filterItem?.filterName == "costCenter") {
              const findValue = costCenterTemp?.find((item: any) => item.value == filterItem?.filterValue)
              filterObj[filterItem?.filterName] = findValue?.label
            } else if (filterItem?.filterName == "updatedBy") {
              const findValue = updatedByTemp?.find((item: any) => item.value == filterItem?.filterValue)
              filterObj[filterItem?.filterName] = findValue?.label
            } else if (filterItem?.filterName == "assignedTo") {
              let findValue:any = {}
              if(activeMenu == CONSTANTS.GRID_ACTIVE_MENU.FLEET_PROCESSING){
                findValue = assignedToTemp?.find((item: any) => item.value == filterItem?.filterValue)
              } else{
                findValue = assignedToColList?.find((item: any) => item.value == filterItem?.filterValue)
              }
              filterObj[filterItem?.filterName] = findValue?.label
            } else if (filterItem?.filterName == "requestedBy") {
              const findValue = requestedByTemp?.find((item: any) => item.value == filterItem?.filterValue)
              filterObj[filterItem?.filterName] = findValue?.label
            } else if (filterItem?.filterName == "regionName") {
              const findValue = regionTemp?.find((item: any) => item.value == filterItem?.filterValue)
              filterObj[filterItem?.filterName] = findValue?.label
            } else if (filterItem?.filterName == "dispositionType") {
              setSelectedDispositionKey(filterItem?.filterValue)
              const findValue = dispositionTypeList?.find((item: any) => item.value == filterItem?.filterValue)
              filterObj[filterItem?.filterName] = findValue?.label
            } else if (filterItem?.filterName == "buyerName") {
              setSelectedBuyerNameKey(filterItem?.filterValue)
              const findValue = buyerNameList?.find((item: any) => item.value == filterItem?.filterValue)
              filterObj[filterItem?.filterName] = findValue?.label
            } else if (filterItem?.filterName == "orderDate" && filterItem?.filterValue) {
              filterObj["orderDate"] = filterItem?.filterValue ? moment(filterItem?.filterValue).format("MM/DD/YYYY") : null
            } else if (filterItem?.filterName == "updatedDate" && filterItem?.filterValue) {
              filterObj["updatedDate"] = filterItem?.filterValue ? moment(filterItem?.filterValue).format("MM/DD/YYYY") : null
            } else if (filterItem?.filterName == "isApprovalOverride" && gridFilterItem?.gridName?.toLowerCase() == HOME_ACTIVE_MENU.ALL_PENDING_APPROVAL?.toLowerCase()) {
              if (filterItem?.filterValue == "") {
                filterObj[filterItem?.filterName] = "All"
              } else if (filterItem?.filterValue == "true") {
                filterObj[filterItem?.filterName] = "Yes"
              } else {
                filterObj[filterItem?.filterName] = "No"
              }
            } else {
              filterObj[filterItem?.filterName] = filterItem?.filterValue
            }
          })

          if (item?.pageName == "Home" && gridFilterItem?.gridName?.toLowerCase() == HOME_ACTIVE_MENU.PENDING_APPROVALS_ORDER?.toLowerCase() && !alreadyHasValues(pendingApprovalGridFilters)) {
            dispatch(GridFiltersAction.setHomePendingApprovalGridFilters(filterObj))
          } else if (item?.pageName == "Home" && gridFilterItem?.gridName?.toLowerCase() == HOME_ACTIVE_MENU.MY_ORDERS?.toLowerCase() && !alreadyHasValues(myOrdersGridFilters)) {
            dispatch(GridFiltersAction.setHomeMyOrdersGridFilters(filterObj))
          } else if (item?.pageName == "Home" && gridFilterItem?.gridName?.toLowerCase() == HOME_ACTIVE_MENU.ALL_PENDING_APPROVAL?.toLowerCase() && !alreadyHasValues(allPendingApprovalGridFilters)) {
            dispatch(GridFiltersAction?.setHomeAllPendingApprovalGridFilters(filterObj))
          } else if (item?.pageName == "Home" && gridFilterItem?.gridName?.toLowerCase() == HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING?.toLowerCase() && !alreadyHasValues(fleetProcessingGridFilters)) {
            dispatch(GridFiltersAction.setHomeFleetProcessingGridFilters(filterObj))
          }
          if (item?.pageName == "Requests" && gridFilterItem?.gridName == "Total Order" && !alreadyHasValues(requestTotalOrderFilters)) {
            filterObj["activeMenu"] = gridFilterItem?.gridName
            dispatch(GridFiltersAction.setRequestGridFilters(filterObj))
          }
          if (item?.pageName == "Requests") {
            if (gridFilterItem?.gridName === CONSTANTS.GRID_ACTIVE_MENU.TOTAL_ORDERS && !alreadyHasValues(requestTotalOrderFilters)) {
              dispatch(GridFiltersAction.setRequestTotalOrderFilters(filterObj))
            } else if (gridFilterItem?.gridName === CONSTANTS.GRID_ACTIVE_MENU.SAVED && !alreadyHasValues(requestSavedOrderFilters)) {
              dispatch(GridFiltersAction.setRequestSavedOrderFilters(filterObj))
            } else if (gridFilterItem?.gridName === CONSTANTS.GRID_ACTIVE_MENU.PENDING_APPROVAL && !alreadyHasValues(requestPendingApprovalFilters)) {
              dispatch(GridFiltersAction.setRequestPendingApprovalFilters(filterObj))
            } else if (gridFilterItem?.gridName === CONSTANTS.GRID_ACTIVE_MENU.FLEET_PROCESSING && !alreadyHasValues(requestFleetProcessingGridFilters)) {
              dispatch(GridFiltersAction.setRequestFleetProcessingFilters(filterObj))
            } else if (gridFilterItem?.gridName === CONSTANTS.GRID_ACTIVE_MENU.COMPLETED && !alreadyHasValues(requestCompletedGridFilters)) {
              dispatch(GridFiltersAction?.setRequestCompletedFilters(filterObj))
            } else if (gridFilterItem?.gridName === CONSTANTS.GRID_ACTIVE_MENU.RETURNED && !alreadyHasValues(requestRetuernedGridFilters)) {
              dispatch(GridFiltersAction.setRequestReturnedFilters(filterObj))
            } else if (gridFilterItem?.gridName === CONSTANTS.GRID_ACTIVE_MENU.PENDING_FLEET_PROCESSING && !alreadyHasValues(requestPendingFleetGridFilters)) {
              dispatch(GridFiltersAction.setRequestPendingFleetFilters(filterObj))
            } else if (gridFilterItem?.gridName === CONSTANTS.GRID_ACTIVE_MENU.REJECTED && !alreadyHasValues(requestRejectedGridFilters)) {
              dispatch(GridFiltersAction.setRequestRejectedFilters(filterObj))
            } else if (gridFilterItem?.gridName === CONSTANTS.GRID_ACTIVE_MENU.CANCELLED && !alreadyHasValues(requestCancelledGridFilters)) {
              dispatch(GridFiltersAction.setRequestCancelledFilters(filterObj))
            }
          }

          if(item?.pageName == "Asset" && gridFilterItem?.gridName == "Total Order" && !alreadyHasValues(assetTotalOrderFilters) ){
            filterObj["activeMenu"] = gridFilterItem?.gridName
            dispatch(GridFiltersAction.setAssetGridFilters(filterObj))
          }
          if(item?.pageName == "Asset"){
            if (gridFilterItem?.gridName === CONSTANTS.GRID_ACTIVE_MENU.TOTAL_ORDERS && !alreadyHasValues(assetTotalOrderFilters)) {
              dispatch(GridFiltersAction.setAssetTotalOrderFilters(filterObj))
           } else if (gridFilterItem?.gridName === CONSTANTS.GRID_ACTIVE_MENU.SAVED && !alreadyHasValues(assetSavedOrderFilters)) {
            dispatch(GridFiltersAction.setAssetSavedOrderFilters(filterObj))
           } else if (gridFilterItem?.gridName === CONSTANTS.GRID_ACTIVE_MENU.PENDING_APPROVAL && !alreadyHasValues(assetPendingApprovalFilters)) {
             dispatch(GridFiltersAction.setAssetPendingApprovalFilters(filterObj))
           } else if (gridFilterItem?.gridName === CONSTANTS.GRID_ACTIVE_MENU.FLEET_PROCESSING && !alreadyHasValues(assetFleetProcessingGridFilters)) {
             dispatch(GridFiltersAction.setAssetFleetProcessingFilters(filterObj))
           } else if (gridFilterItem?.gridName === CONSTANTS.GRID_ACTIVE_MENU.COMPLETED && !alreadyHasValues(assetCompletedGridFilters)) {
             dispatch(GridFiltersAction?.setAssetCompletedFilters(filterObj))
           } else if (gridFilterItem?.gridName === CONSTANTS.GRID_ACTIVE_MENU.RETURNED && !alreadyHasValues(assetRetuernedGridFilters)) {
             dispatch(GridFiltersAction.setAssetReturnedFilters(filterObj))
           } else if (gridFilterItem?.gridName === CONSTANTS.GRID_ACTIVE_MENU.PENDING_FLEET_PROCESSING && !alreadyHasValues(assetPendingFleetGridFilters)) {
             dispatch(GridFiltersAction.setAssetPendingFleetFilters(filterObj))
           } else if (gridFilterItem?.gridName === CONSTANTS.GRID_ACTIVE_MENU.REJECTED && !alreadyHasValues(assetRejectedGridFilters)) {
             dispatch(GridFiltersAction.setAssetRejectedFilters(filterObj))
           } else if (gridFilterItem?.gridName === CONSTANTS.GRID_ACTIVE_MENU.CANCELLED && !alreadyHasValues(assetCancelledGridFilters)) {
             dispatch(GridFiltersAction.setAssetCancelledFilters(filterObj))
           }
          }

          if(item?.pageName == "Bulk Orders" && gridFilterItem?.gridName == "Total Order" && !alreadyHasValues(bulkOrderTotalOrderFilters)){
            filterObj["activeMenu"] = gridFilterItem?.gridName
            dispatch(GridFiltersAction.setBulkOrderGridFilters(filterObj))
          }
          if(item?.pageName == "Bulk Orders"){
            if (gridFilterItem?.gridName === CONSTANTS.GRID_ACTIVE_MENU.TOTAL_ORDERS && !alreadyHasValues(bulkOrderTotalOrderFilters)) {
              dispatch(GridFiltersAction.setBulkOrderTotalOrderFilters(filterObj))
           } else if (gridFilterItem?.gridName === CONSTANTS.GRID_ACTIVE_MENU.SAVED && !alreadyHasValues(bulkOrderSavedOrderFilters)) {
            dispatch(GridFiltersAction.setBulkOrderSavedOrderFilters(filterObj))
           } else if (gridFilterItem?.gridName === CONSTANTS.GRID_ACTIVE_MENU.PENDING_APPROVAL && !alreadyHasValues(bulkOrderPendingApprovalFilters)) {
             dispatch(GridFiltersAction.setBulkOrderPendingApprovalFilters(filterObj))
           } else if (gridFilterItem?.gridName === CONSTANTS.GRID_ACTIVE_MENU.FLEET_PROCESSING && !alreadyHasValues(bulkOrderFleetProcessingGridFilters)) {
             dispatch(GridFiltersAction.setBulkOrderFleetProcessingFilters(filterObj))
           } else if (gridFilterItem?.gridName === CONSTANTS.GRID_ACTIVE_MENU.COMPLETED && !alreadyHasValues(bulkOrderCompletedGridFilters)) {
             dispatch(GridFiltersAction?.setBulkOrderCompletedFilters(filterObj))
           } else if (gridFilterItem?.gridName === CONSTANTS.GRID_ACTIVE_MENU.RETURNED && !alreadyHasValues(bulkOrderReturnedGridFilters)) {
             dispatch(GridFiltersAction.setBulkOrderReturnedFilters(filterObj))
           } else if (gridFilterItem?.gridName === CONSTANTS.GRID_ACTIVE_MENU.REJECTED && !alreadyHasValues(bulkOrderRejectedGridFilters )) {
             dispatch(GridFiltersAction.setBulkOrderRejectedFilters(filterObj))
           } else if (gridFilterItem?.gridName === CONSTANTS.GRID_ACTIVE_MENU.CANCELLED && !alreadyHasValues(bulkOrderCancelledGridFilters)) {
             dispatch(GridFiltersAction.setBulkOrderCancelledFilters(filterObj))
           }
          }
        })
      })

      if (isAuthorized(permissions.ApprovalsView) || isAuthorized(permissions.CreateUpdatePurchaseOrders)) {
        setactiveMenu(HOME_ACTIVE_MENU.PENDING_APPROVALS_ORDER)
      } else{
        setactiveMenu(HOME_ACTIVE_MENU.MY_ORDERS)
      }
    }
  }

  useEffect(() => {
    if (userDetails?.emailId) {
      const defaultMenu = (isAuthorized(permissions.ApprovalsView) || isAuthorized(permissions.CreateUpdatePurchaseOrders))
        ? HOME_ACTIVE_MENU.PENDING_APPROVALS_ORDER
        : HOME_ACTIVE_MENU.MY_ORDERS

      const resolvedMenu = latestSelectedMenuRef.current
        ?? pendingApprovalGridFilters?.activeMenu
        ?? myOrdersGridFilters?.activeMenu
        ?? fleetProcessingGridFilters?.activeMenu
        ?? allPendingApprovalGridFilters?.activeMenu
        ?? defaultMenu

      if (resolvedMenu !== activeMenu) {
        setactiveMenu(resolvedMenu)
      }

      if (!latestSelectedMenuRef.current) {
        latestSelectedMenuRef.current = resolvedMenu
        scheduleGridRefresh()
      }

      if (resolvedMenu === HOME_ACTIVE_MENU.PENDING_APPROVALS_ORDER) {
        setFilteredOrderList(pendingOrdersGridData?.data)
        setServerTotal(pendingOrdersGridData?.totalRecords)
        setServerPageNumber(pendingOrdersGridData?.pageNumber ?? 1)
      } else if (resolvedMenu === HOME_ACTIVE_MENU.MY_ORDERS) {
        setFilteredOrderList(myOrdersGridData?.data)
        setServerTotal(myOrdersGridData?.totalRecords)
        setServerPageNumber(myOrdersGridData?.pageNumber ?? 1)
      } else if (resolvedMenu === HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
        setFilteredOrderList(fleetProcessingGridData?.data)
        setServerTotal(fleetProcessingGridData?.totalRecords)
        setServerPageNumber(fleetProcessingGridData?.pageNumber ?? 1)
      } else if(resolvedMenu === HOME_ACTIVE_MENU?.ALL_PENDING_APPROVAL){
        setFilteredOrderList(allPendingGridData?.data)
        setServerTotal(allPendingGridData?.totalRecords)
        setServerPageNumber(allPendingGridData?.pageNumber ?? 1)
      }
    }
  }, [JSON.stringify(userDetails), myOrdersGridData, fleetProcessingGridData, pendingOrdersGridData, allPendingGridData])

  const onSearchOrder = (e: any, isKeyPress?: any) => {
    setsearchBoxValue((isKeyPress ? e :e?.target?.value))
    if (activeMenu === HOME_ACTIVE_MENU.PENDING_APPROVALS_ORDER) {
      dispatch(GridFiltersAction.setHomePendingApprovalGridFilters({ orderSearchBoxValue: (isKeyPress ? e :e?.target?.value) }))
    } else if (activeMenu === HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
      dispatch(GridFiltersAction.setHomeFleetProcessingGridFilters({ orderSearchBoxValue: (isKeyPress ? e :e?.target?.value) }))
    } else if(activeMenu === HOME_ACTIVE_MENU?.ALL_PENDING_APPROVAL){
      dispatch(GridFiltersAction?.setHomeAllPendingApprovalGridFilters({orderSearchBoxValue: (isKeyPress ? e :e?.target?.value)}))
    } else {
      dispatch(GridFiltersAction.setHomeMyOrdersGridFilters({ orderSearchBoxValue: (isKeyPress ? e :e?.target?.value) }))
    }
  }

  const onDateChangeFunction = (e: any) => {
    setdateRange(e);
    if (activeMenu === HOME_ACTIVE_MENU.PENDING_APPROVALS_ORDER) {
      dispatch(GridFiltersAction.setHomePendingApprovalGridFilters({ dateRange: e }))
    } else if (activeMenu === HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
      dispatch(GridFiltersAction.setHomeFleetProcessingGridFilters({ dateRange: e }))
    } else if(activeMenu === HOME_ACTIVE_MENU.ALL_PENDING_APPROVAL){
      dispatch(GridFiltersAction.setHomeAllPendingApprovalGridFilters({ dateRange: e }))
    } else {
      dispatch(GridFiltersAction.setHomeMyOrdersGridFilters({ dateRange: e }))
    }
  }

  const handleClick = (item: any) => {
    latestSelectedMenuRef.current = item
    if(item == HOME_ACTIVE_MENU.PENDING_APPROVALS_ORDER){
      delete pendingApprovalGridFilters.orderSearchBoxValue
      delete pendingApprovalGridFilters.globalSearchField
      delete pendingApprovalGridFilters.orderId
      delete pendingApprovalGridFilters.orderPrice
      delete pendingApprovalGridFilters.frsOrderNumber
      delete pendingApprovalGridFilters.comment
    }
    if(item == HOME_ACTIVE_MENU.ALL_PENDING_APPROVAL){
      delete allPendingApprovalGridFilters.orderSearchBoxValue
      delete allPendingApprovalGridFilters.globalSearchField
      delete allPendingApprovalGridFilters.orderId
      delete allPendingApprovalGridFilters.orderPrice
      delete allPendingApprovalGridFilters.frsOrderNumber
      delete allPendingApprovalGridFilters.comment
    }
    if(item == HOME_ACTIVE_MENU.MY_ORDERS){
      delete myOrdersGridFilters.orderSearchBoxValue
      delete myOrdersGridFilters.globalSearchField
      delete myOrdersGridFilters.orderId
      delete myOrdersGridFilters.orderPrice
      delete myOrdersGridFilters.frsOrderNumber
      delete myOrdersGridFilters.comment
    }
    if(item == HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING){
      delete fleetProcessingGridFilters.orderSearchBoxValue
      delete fleetProcessingGridFilters.globalSearchField
      delete fleetProcessingGridFilters.orderId
      delete fleetProcessingGridFilters.orderPrice
      delete fleetProcessingGridFilters.frsOrderNumber
      delete fleetProcessingGridFilters.comment
    }
    dispatch(GridFiltersAction.setHomeMyOrdersGridFilters({...myOrdersGridFilters, activeMenu: item }))
    dispatch(GridFiltersAction.setHomePendingApprovalGridFilters({...pendingApprovalGridFilters, activeMenu: item }))
    dispatch(GridFiltersAction?.setHomeAllPendingApprovalGridFilters({...allPendingApprovalGridFilters, activeMenu: item }))
    dispatch(GridFiltersAction.setHomeFleetProcessingGridFilters({...fleetProcessingGridFilters, activeMenu: item }))
    setActiveHomeFilterState(item)
    setactiveMenu(item)
    scheduleGridRefresh()
  }


  useEffect(() => {
    const defaultMenu = (isAuthorized(permissions.ApprovalsView) || isAuthorized(permissions.CreateUpdatePurchaseOrders))
      ? HOME_ACTIVE_MENU.PENDING_APPROVALS_ORDER
      : HOME_ACTIVE_MENU.MY_ORDERS

    const resolvedMenu = latestSelectedMenuRef.current
      ?? pendingApprovalGridFilters?.activeMenu
      ?? myOrdersGridFilters?.activeMenu
      ?? fleetProcessingGridFilters?.activeMenu
      ?? allPendingApprovalGridFilters?.activeMenu
      ?? defaultMenu

    if (resolvedMenu !== activeMenu) {
      setactiveMenu(resolvedMenu)
    }

    if (resolvedMenu === HOME_ACTIVE_MENU.PENDING_APPROVALS_ORDER) {
      setsearchBoxValue(pendingApprovalGridFilters?.orderSearchBoxValue || '');
      setGlobalSearchBy(pendingApprovalGridFilters?.globalSearchField ?? { value: 'orderId', label: 'Order#' })
    } else if (resolvedMenu === HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
      setsearchBoxValue(fleetProcessingGridFilters?.orderSearchBoxValue || '');
      setGlobalSearchBy(fleetProcessingGridFilters?.globalSearchField ?? { value: 'orderId', label: 'Order#' })
      setSelectedAssignedTo(fleetProcessingGridFilters?.assignedToFilter ? assignedToTemp?.find((opt: any) => opt.value === fleetProcessingGridFilters?.assignedToFilter) : { label: "All", value: "All" })
    } else if (resolvedMenu === HOME_ACTIVE_MENU?.ALL_PENDING_APPROVAL) {
      setsearchBoxValue(allPendingApprovalGridFilters?.orderSearchBoxValue || '')
      setGlobalSearchBy(allPendingApprovalGridFilters?.globalSearchField ?? { value: 'orderId', label: 'Order#' })
    } else {
      setsearchBoxValue(myOrdersGridFilters?.orderSearchBoxValue || '')
      setGlobalSearchBy(myOrdersGridFilters?.globalSearchField ?? { value: 'orderId', label: 'Order#' })
    }

    if (resolvedMenu === HOME_ACTIVE_MENU.PENDING_APPROVALS_ORDER) {
      if (pendingApprovalGridFilters?.dateRange?.length) {
        setdateRange(pendingApprovalGridFilters?.dateRange)
      } else {
        setdateRange([]);
      }
    } else if (resolvedMenu === HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
      if (fleetProcessingGridFilters?.dateRange?.length) {
        setdateRange(fleetProcessingGridFilters?.dateRange)
      } else {
        setdateRange([]);
      }
    } else if (resolvedMenu === HOME_ACTIVE_MENU.MY_ORDERS) {
      if (myOrdersGridFilters?.dateRange?.legnth) {
        setdateRange(myOrdersGridFilters?.dateRange)
      } else {
        setdateRange([]);
      }
    } else if(resolvedMenu === HOME_ACTIVE_MENU?.ALL_PENDING_APPROVAL){
      if (allPendingApprovalGridFilters?.dateRange?.length) {
        setdateRange(allPendingApprovalGridFilters?.dateRange)
      } else {
        setdateRange([]);
      }
    }
    if (resolvedMenu === 'MY ORDERS') {
      setgridData(myOrdersGridData?.data);
      setFilteredOrderList(myOrdersGridData?.data)
    }
    else if (resolvedMenu === HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
      setgridData(fleetProcessingGridData?.data);
      setFilteredOrderList(fleetProcessingGridData?.data);
    } 
    else if(resolvedMenu === HOME_ACTIVE_MENU?.ALL_PENDING_APPROVAL){
      setgridData(allPendingGridData?.data);
      setFilteredOrderList(allPendingGridData?.data);
    }
    else {
      setgridData(pendingOrdersGridData?.data);
      setFilteredOrderList(pendingOrdersGridData?.data)
    }
  }, [activeMenu, pendingApprovalGridFilters, myOrdersGridFilters, fleetProcessingGridFilters, allPendingApprovalGridFilters, pendingOrdersGridData, myOrdersGridData, fleetProcessingGridData, allPendingGridData, assignedToTemp, scheduleGridRefresh])

  const onExportExcel = (_e: any) => {
    if (gridData) {
      let dataTable: any[] = [];
      let columnHeaders: any[] = [];
      gridData.forEach((item: any) => {
        let excelData: any = {};
        gridColumns.forEach((colDef: any) => {
          if (colDef?.title != 'Action') {
            const colName = colDef?.title;
            const key = colDef?.key;
            let colValue = ''
            if (key == 'dateSubmitted' || key == 'dateUpdated') {
              const formatDate = moment(item[key]).format('MM/DD/YYYY')
              colValue = formatDate ?? '';
            } else {
              colValue = item[key] ?? '';
            }
            excelData[colName] = colValue;
            if (columnHeaders.length != Object.keys(gridData).length) {
              columnHeaders.push(colName);
            }
          }
        });
        dataTable.push(excelData);
      });
      commonExportExcel(dataTable, columnHeaders, 'Pending Approval Order', 'Pending Approval Order.xlsx')
    }
  }

  const OrderList = () => {
    if (getUserRoles()?.includes(CONSTANTS?.FLEET_ADMIN) || getUserRoles()?.includes(CONSTANTS?.SUPER_ADMIN) || isAuthorized(permissions?.ViewAllPendingApprovals) || isAuthorized(FLEET_PROCESSING_PERMISSIONS?.VIEW_PURCHASEORDERS)) {
      if(isAuthorized(permissions.SuperApproval_Approvals) || isAuthorized(permissions?.ViewAllPendingApprovals)){
        return superAdminUserGrid
     }
      return orderListApprover
    }
    else if (getUserRoles()?.includes(CONSTANTS?.EQUIPMENT_ORDERER)
      || getUserRoles()?.includes(CONSTANTS?.FIXED_ASSET_ACCOUNTING)
      || getUserRoles()?.includes(CONSTANTS?.SHARED_SERVICES)) {
      return EquipmentOrderList;
    }
    else if (getUserRoles()?.includes('Approver')) {
      return approvalsPending;
    }
    return userDetails?.userId ? orders : [];
  }

  const activeNavigation = useSelector((state: any) => state.nav.nav)
  useEffect(() => {
    document.getElementsByClassName('content-wrapper')[0].scrollTop = 0;
  }, [activeNavigation]);

  const clearFilterValues = {
    orderId: '',
    status: '',
    orderDate: null,
    regionName: '',
    costCenter: '',
    quantity: '',
    orderRequestType: '',
    requestedBy: '',
    updatedDate: null,
    updatedBy: '',
    assignedTo: '',
    orderPrice: '',
    frsOrderNumber: '',
    comment: '',
    orderSearchBoxValue: '',
    dateRange: [],
    fleetItemStatus: '',
    assignedToFilter: '',
    loggedInMail: '',
    dispositionType: '',
    isApprovalOverride: 'All',
    buyerName: '',
    globalSearchField: null
  }

  const handleFilterClear = () => {
    latestSelectedMenuRef.current = null
    if (activeMenu === HOME_ACTIVE_MENU.PENDING_APPROVALS_ORDER) {
      dispatch(GridFiltersAction.setHomePendingApprovalGridFilters(clearFilterValues))
    } else if (activeMenu === HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
      dispatch(GridFiltersAction.setHomeFleetProcessingGridFilters(clearFilterValues))
    } else if(activeMenu === HOME_ACTIVE_MENU?.ALL_PENDING_APPROVAL){
      dispatch(GridFiltersAction?.setHomeAllPendingApprovalGridFilters(clearFilterValues))
    } else {
      dispatch(GridFiltersAction.setHomeMyOrdersGridFilters(clearFilterValues))
    }
    setsearchBoxValue('')
    setGlobalSearchBy({ value:'orderId',label:'Order#'})
    setdateRange([])
    setSelectedAssignedTo({label:"All", value:"All"})
    setClearFiltersKey((key: number) => key + 1)
    scheduleGridRefresh()
    if (activeMenu === HOME_ACTIVE_MENU.PENDING_APPROVALS_ORDER) {
      setactiveMenu(HOME_ACTIVE_MENU.MY_ORDERS)
    } else if (activeMenu === HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
      setactiveMenu(HOME_ACTIVE_MENU.MY_ORDERS)
    } else {
      setactiveMenu(HOME_ACTIVE_MENU.PENDING_APPROVALS_ORDER)
    }
    setactiveMenu(pendingApprovalGridFilters?.activeMenu || HOME_ACTIVE_MENU.PENDING_APPROVALS_ORDER)
  }

  const assignedToOption = [
    { value:'All',label:'All'},
    { value:'Assigned',label:'Assigned'},
    { value:'Unassigned',label:'Unassigned'}
  ];

  const onAssignedToChange = (e?: any, item?: any) => {
   setSelectedAssignedTo(e)
   if (activeMenu === HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
    dispatch(GridFiltersAction.setHomeFleetProcessingGridFilters({ assignedToFilter: e?.value , loggedInMail: userDetails?.emailId}))
  }
  }

  const onGlobalSearchByChange = (value: any) => {
    setGlobalSearchBy(value)
    if (activeMenu === HOME_ACTIVE_MENU.PENDING_APPROVALS_ORDER) {
      dispatch(GridFiltersAction.setHomePendingApprovalGridFilters({ globalSearchField: value }))
    } else if (activeMenu === HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
      dispatch(GridFiltersAction.setHomeFleetProcessingGridFilters({ globalSearchField: value }))
    } else if(activeMenu === HOME_ACTIVE_MENU?.ALL_PENDING_APPROVAL){
      dispatch(GridFiltersAction?.setHomeAllPendingApprovalGridFilters({ globalSearchField: value }))
    } else {
      dispatch(GridFiltersAction.setHomeMyOrdersGridFilters({ globalSearchField: value }))
    }
  }

  const alreadyHasGridFilterValues = useCallback(() => {
    let isAlreadyHasValues = true
    let GridFilterValueTemp: any = {}
    if (activeMenu === HOME_ACTIVE_MENU.PENDING_APPROVALS_ORDER) {
      GridFilterValueTemp = pendingApprovalGridFilters
    } else if (activeMenu === HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
      GridFilterValueTemp = fleetProcessingGridFilters
    } else if (activeMenu === HOME_ACTIVE_MENU?.ALL_PENDING_APPROVAL) {
      GridFilterValueTemp = allPendingApprovalGridFilters
    } else {
      GridFilterValueTemp = myOrdersGridFilters
    }
    Object.keys(clearFilterValues)?.forEach((filterItem?: any) => {
      Object.keys(GridFilterValueTemp ?? {})?.forEach((gridItem?: any) => {
        if (filterItem == gridItem) {
          let val = gridItem
          if (val == "isApprovalOverride" && activeMenu === HOME_ACTIVE_MENU?.ALL_PENDING_APPROVAL) {
            if (GridFilterValueTemp[val] != "All" && GridFilterValueTemp[val] != null && GridFilterValueTemp[val] != undefined && GridFilterValueTemp[val] != "") {
              isAlreadyHasValues = false
            }
          } else if (val == "assignedToFilter" && activeMenu === HOME_ACTIVE_MENU?.PENDING_FLEET_PROCESSING) {
            if (GridFilterValueTemp[val] != "All" && GridFilterValueTemp[val] != null && GridFilterValueTemp[val] != undefined && GridFilterValueTemp[val] != '') {
              isAlreadyHasValues = false
            }
          }
          else if (GridFilterValueTemp[val] != "" && GridFilterValueTemp[val] != null && GridFilterValueTemp[val] != undefined && val != "dateRange" && val != "globalSearchField" && val != "isApprovalOverride" && val != "assignedToFilter" && val != "loggedInMail") {
            isAlreadyHasValues = false
          } else if (val == "dateRange") {
            if (GridFilterValueTemp[val]?.length) {
              isAlreadyHasValues = false
            }
          }
        }
      })
    })
    return isAlreadyHasValues
  }, [pendingApprovalGridFilters, fleetProcessingGridFilters, allPendingApprovalGridFilters, myOrdersGridFilters])

  return <CreateNewOrder
    activeMenu={activeMenu}
    handleClick={handleClick}
    onSearchOrder={onSearchOrder}
    filteredOrderList={filteredOrderList}
    onExportExcel={onExportExcel}
    orderList={OrderList()}
    BranchList={BranchList}
    onDateChange={onDateChangeFunction}
    searchBoxValue={searchBoxValue}
    dateRange={dateRange}
    showUserManagementPopup={showUserManagementPopup}
    hidePopup={hidePopup}
    showGrid={showGrid}
    clearFiltersKey={clearFiltersKey}
    myOrder={activeMenu === "MY ORDERS"}
    handleFilterClear={handleFilterClear}
    pendingApprovalGridFilters={pendingApprovalGridFilters}
    myOrdersGridFilters={myOrdersGridFilters}
    fleetProcessingGridFilters={fleetProcessingGridFilters}
    serverTotal={serverTotal}
    serverPageNumber={serverPageNumber}
    assignedToOption={assignedToOption}
    selectedAssignedTo = {selectedAssignedTo}
    onAssignedToChange={onAssignedToChange}
    allPendingApprovalGridFilters={allPendingApprovalGridFilters}
    activeHomeFilterState={activeHomeFilterState}
    assignedToTemp = {assignedToTemp}
    requestedByTemp = {requestedByTemp}
    regionTemp = {regionTemp}
    costCenterTemp = {costCenterTemp}
    updatedByTemp = {updatedByTemp}
    setSelectedDispositionKey = {setSelectedDispositionKey}
    selectedDispositionKey = {selectedDispositionKey}
    setDispositionTypeList = {setDispositionTypeList}
    dispositionTypeList = {dispositionTypeList}
    isGridCountsLoading={isGridCountsLoading}
    buyerNameList = {buyerNameList}
    setSelectedBuyerNameKey = {setSelectedBuyerNameKey}
    selectedBuyerNameKey = {selectedBuyerNameKey}
    setBuyerNameList = {setBuyerNameList}
    searchByOptions={searchByOptions}
    globalSearchBy={globalSearchBy}
    onGlobalSearchByChange={onGlobalSearchByChange}
    assignedToColList={assignedToColList}
    alreadyHasGridFilterValues = {alreadyHasGridFilterValues}
  />
}

export default CreateNewOrderContainer